module.exports = __webpack_public_path__ + "img/yodlee.8a4c0300.jpg";